<style lang="less" scoped src="@/assets/less/manage-space/base.less"></style>
<template>
    <div>
        <!-- search and actions start -->
        <div class="d-flex align-items-center justify-content-between">
            <CoInput
                v-model="search"
                type="search"
                :placeholder="$t('placeholders.search')"
                class="mr-2"
                icon="search"
                no-border
                background="white"
            ></CoInput>

            <!-- sync available keys/tags button -->
            <div class="d-flex align-items-center">
                <CoButton
                    variant="secondary"
                    role="button"
                    :title="$t('labels.import')"
                    @click="importLocks()"
                    class="mr-2"
                    :loading="loading"
                >
                    {{ $t('labels.import') }}
                </CoButton>
            </div>
        </div>
        <!-- search and actions end -->
        <CoTable
            :loading="loading"
            :itemsPerPage="10"
            :items="filteredItems"
            resizable-columns
            auto-items-per-page
            :columns="[
                { key: 'Name', title: 'Name', sortable: true },
                { key: 'Provider', title: 'Provider', sortable: true },
            ]"
        >
        </CoTable>
    </div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';
import EventBus from '@/eventBus';

export default {
    name: 'Locks',
    components: {},
    data() {
        return {
            loading: false,
            objects: [],
            search: '',
        };
    },
    mounted() {
        this.listLocks();
    },
    computed: {
        filteredItems() {
            return this.objects.filter((item) => {
                if (item.Name.toLowerCase().indexOf(this.search.toLowerCase()) > -1) {
                    return true;
                }
                return item.Provider.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
            });
        },
    },
    methods: {
        listLocks() {
            this.loading = true;
            axios
                .get('/admin/space/access/lock/list')
                .then((response) => {
                    if (response && response.data) {
                        this.objects = response.data;
                    }
                    this.loading = false;
                })
                .catch((error) => {
                    console.log(error);
                    this.loading = false;
                });
        },
        importLocks() {
            this.loading = true;
            axios
                .get('/admin/space/access/lock/import')
                .then((response) => {
                    if (response && response.data) {
                        this.objects = response.data;
                    }
                    this.loading = false;
                })
                .catch((error) => {
                    console.log(error);
                    this.loading = false;
                });
        },
    },
};
</script>
